import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  justifyContent: 'space-around',
  alignItems: 'center',
  textAlign: 'center',
  minHeight: '74px',
  marginBottom: '400',
});

export const detailContainerStyles = css.raw({
  flexGrow: 1,
  margin: '0 {spacing.400}',
  width: 0,
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export const verticalLineStyles = css.raw({
  flexGrow: 0,
  width: '1px',
  height: '51px',
  background: 'bg.soft',
});

export const statisticsComponentStyles = css.raw({
  flexGrow: 3,
  minHeight: '140px',
  textAlign: 'center',
  overflow: 'hidden',
  '& .ResponsiveContainer-BarChart': {
    marginBottom: '200',
    height: '70px !important',
    pointerEvents: 'none',
  },
});
